export const USER_SIGN_UP_REQUEST =  "USER_SIGN_UP_REQUEST"
export const USER_SIGN_UP_SUCCESS =  "USER_SIGN_UP_SUCCESS"
export const USER_SIGN_UP_FAIL =  "USER_SIGN_UP_FAIL"
export const USER_SIGN_UP_RESET =  "USER_SIGN_UP_RESET"

export const USER_SIGN_IN_REQUEST =  "USER_SIGN_IN_REQUEST"
export const USER_SIGN_IN_SUCCESS =  "USER_SIGN_IN_SUCCESS"
export const USER_SIGN_IN_FAIL =  "USER_SIGN_IN_FAIL"
export const USER_SIGN_IN_RESET =  "USER_SIGN_IN_RESET"
export const USER_LOGOUT = "USER_LOGOUT"

export const POST_CATEGORY_REQUEST =  "POST_CATEGORY_REQUEST"
export const POST_CATEGORY_SUCCESS =  "POST_CATEGORY_SUCCESS"
export const POST_CATEGORY_FAIL =  "POST_CATEGORY_FAIL"
export const POST_CATEGORY_RESET =  "POST_CATEGORY_RESET"

export const POST_ITEM_REQUEST =  "POST_ITEM_REQUEST"
export const POST_ITEM_SUCCESS =  "POST_ITEM_SUCCESS"
export const POST_ITEM_FAIL =  "POST_ITEM_FAIL"
export const POST_ITEM_RESET =  "POST_ITEM_RESET"

export const GET_CATEGORY_REQUEST =  "GET_CATEGORY_REQUEST"
export const GET_CATEGORY_SUCCESS =  "GET_CATEGORY_SUCCESS"
export const GET_CATEGORY_FAIL =  "GET_CATEGORY_FAIL"
export const GET_CATEGORY_RESET =  "GET_CATEGORY_RESET"

export const GET_PRODUCT_REQUEST =  "GET_PRODUCT_REQUEST"
export const GET_PRODUCT_SUCCESS =  "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_FAIL =  "GET_PRODUCT_FAIL"
export const GET_PRODUCT_RESET =  "GET_PRODUCT_RESET"
